import sdk from 'Modules/api/services/sdk';
import {
  createUserFailure,
  createUserRequest,
  createUserSuccess,
  loginUser,
} from 'Modules/auth/actions';
import { getActiveLocale } from '@openclassrooms/translations';
import { setCurrentUserId } from 'Modules/currentUser/actions';

import actionTypes from '../actions/types';

const signUpMiddleware = (store) => (next) => async (action) => {
  if (action.type === actionTypes.POST_CREATE_USER_TRIGGER) {
    store.dispatch(createUserRequest());
    try {
      const createUserResponse = await sdk.client
        .createPostRequest('/users')
        .setBodyParams(action.payload.values)
        .setHeader('Accept-Language', getActiveLocale())
        .execute();

      if (!createUserResponse.body || !createUserResponse.body.id) {
        return store.dispatch(createUserFailure(createUserResponse));
      }

      store.dispatch(createUserSuccess(createUserResponse.body));

      sdk.switchToConnectedClient();

      store.dispatch(setCurrentUserId(createUserResponse.body.id));

      store.dispatch(
        loginUser({
          _username: action.payload.values.email,
          csrfToken: action.payload.csrfToken,
          _password: createUserResponse.body.password,
          redirectLink: action.payload.redirectLink,
          userId: createUserResponse.body.id,
          subscribeNewsletter: action.payload.subscribeNewsletter,
          isFirstTime: true,
          hasNoWelcomeQuestions: action.payload.hasNoWelcomeQuestions,
          authContext: action.payload.authContext,
        })
      );
    } catch (error) {
      return store.dispatch(createUserFailure(error));
    }
  }

  return next(action);
};

export default signUpMiddleware;
